import { Injectable } from '@angular/core';
import { CommonService } from '../common/common.service';
import { Router } from '@angular/router';
import { SharedService } from '../shared-service/shared.service';
import { PermissionStore } from '../permission-service/permission.store';

@Injectable({
  providedIn: 'root'
})

export class AuthService {

  constructor(
    private sharedService: SharedService,
    public commonService: CommonService,
    private route: Router,
    private readonly permissionStore: PermissionStore
  ) { }

  isLoggedIn(): boolean {
    const userId = this.sharedService.getValue('userId');
    return !!userId;
  }

  logout() {
    this.permissionStore.clear();
    this.sharedService.clearStorage();
    this.route.navigate(["/login"]);
  }
}